// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/article-filter/article-filter.component.scss
// module id = 374
// module chunks = 0